
import { Question } from '../types';

export const taj101WaqfQuestions: Question[] = [
  {
    id: 'taj081',
    text: 'What does waqf mean in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'To stop at the end of a word with the intention of continuing recitation', isCorrect: true },
      { id: 'b', text: 'To cut the recitation completely', isCorrect: false },
      { id: 'c', text: 'To stop the sound without breaking the breath', isCorrect: false },
      { id: 'd', text: 'To join two words without pausing', isCorrect: false }
    ],
    explanation: 'Waqf (وَقْف) literally means to stop. Technically, it is to stop at the end of a complete word long enough to renew the breath with the intention of continuing recitation.',
    topic: 'taj101'
  },
  {
    id: 'taj082',
    text: 'How does qaṭʿ differ from waqf?',
    type: 'single',
    options: [
      { id: 'a', text: 'It means to end recitation without the intention of continuing', isCorrect: true },
      { id: 'b', text: 'It means to stop temporarily and then continue', isCorrect: false },
      { id: 'c', text: 'It means to stop without taking a breath', isCorrect: false },
      { id: 'd', text: 'It means to connect one word to another', isCorrect: false }
    ],
    explanation: 'Qaṭʿ (قَطْع) literally means to cut. Technically it means to cut or end the recitation without the intention of continuing. Qaṭʿ is only allowed at the end of āyāt.',
    topic: 'taj101'
  },
  {
    id: 'taj083',
    text: 'What is sakt in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'To stop the sound while reciting without breaking the breath', isCorrect: true },
      { id: 'b', text: 'To end recitation completely', isCorrect: false },
      { id: 'c', text: 'To stop at the end of a word to take a breath', isCorrect: false },
      { id: 'd', text: 'To join two words together', isCorrect: false }
    ],
    explanation: 'Sakt (سَكْت) literally means silence. Technically, it means to stop the sound whilst reciting without breaking the breath.',
    topic: 'taj101'
  },
  {
    id: 'taj084',
    text: 'What are the three factors considered when discussing waqf?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The condition of the qāriʾ', isCorrect: true },
      { id: 'b', text: 'The place where the qāriʾ stops', isCorrect: true },
      { id: 'c', text: 'The ḥarakah of the last letter upon which waqf is being made', isCorrect: true },
      { id: 'd', text: 'The number of verses being recited', isCorrect: false }
    ],
    explanation: 'When discussing waqf, there are three things which are considered: the condition of the qāriʾ, the place where the qāriʾ stops, and the ḥarakah of the last letter upon which waqf is being made.',
    topic: 'taj101'
  },
  {
    id: 'taj085',
    text: 'What are the four types of waqf when considering the condition of the qāriʾ?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Al-waqf al-ikhtiḥārī (the examinatory stop)', isCorrect: true },
      { id: 'b', text: 'Al-waqf al-intiẓārī (the adjourning stop)', isCorrect: true },
      { id: 'c', text: 'Al-waqf al-iḍṭirārī (the forced stop)', isCorrect: true },
      { id: 'd', text: 'Al-waqf al-ikhtiyārī (the voluntary stop)', isCorrect: true }
    ],
    explanation: 'When considering the condition of the qāriʾ, waqf is of four types: al-waqf al-ikhtiḥārī (the examinatory stop), al-waqf al-intiẓārī (the adjourning stop), al-waqf al-iḍṭirārī (the forced stop), and al-waqf al-ikhtiyārī (the voluntary stop).',
    topic: 'taj101'
  },
  {
    id: 'taj086',
    text: 'What is al-waqf al-ikhtiḥārī (the examinatory stop)?',
    type: 'single',
    options: [
      { id: 'a', text: 'A stop made when being tested by a teacher', isCorrect: true },
      { id: 'b', text: 'A stop made to complete various Qirāʾāt', isCorrect: false },
      { id: 'c', text: 'An involuntary stop due to a cough or sneeze', isCorrect: false },
      { id: 'd', text: 'A voluntary stop chosen by the reciter', isCorrect: false }
    ],
    explanation: 'Al-waqf al-ikhtiḥārī (the examinatory stop) is made when being tested (e.g., by a teacher). This waqf is allowed (jāʾiz) with the condition that the qāriʾ starts his recitation from that particular word again if it doesn\'t distort the meaning.',
    topic: 'taj101'
  },
  {
    id: 'taj087',
    text: 'What is al-waqf al-intiẓārī (the adjourning stop)?',
    type: 'single',
    options: [
      { id: 'a', text: 'A stop made to complete the various Qirāʾāt', isCorrect: true },
      { id: 'b', text: 'A stop made when being tested by a teacher', isCorrect: false },
      { id: 'c', text: 'An involuntary stop due to a cough or sneeze', isCorrect: false },
      { id: 'd', text: 'A voluntary stop chosen by the reciter', isCorrect: false }
    ],
    explanation: 'Al-waqf al-intiẓārī (the adjourning stop) is made on a particular place solely to complete the various Qirāʾāt. This waqf is also allowed, and the qāriʾ will continue reading from that particular word in which the difference of opinion is found.',
    topic: 'taj101'
  },
  {
    id: 'taj088',
    text: 'What is al-waqf al-iḍṭirārī (the forced stop)?',
    type: 'single',
    options: [
      { id: 'a', text: 'An involuntary stop caused by a cough, sneeze, etc.', isCorrect: true },
      { id: 'b', text: 'A stop made when being tested by a teacher', isCorrect: false },
      { id: 'c', text: 'A stop made to complete the various Qirāʾāt', isCorrect: false },
      { id: 'd', text: 'A voluntary stop chosen by the reciter', isCorrect: false }
    ],
    explanation: 'Al-waqf al-iḍṭirārī (the forced stop) is an involuntary stop made by the qāriʾ which is caused by an unplanned break in his breath due to a cough, sneeze, etc. This waqf is allowed even though the meaning will be incomplete.',
    topic: 'taj101'
  },
  {
    id: 'taj089',
    text: 'What are the four types of waqf when considering the place where the qāriʾ stops?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Al-waqf at-tāmm (the complete stop)', isCorrect: true },
      { id: 'b', text: 'Al-waqf al-kāfī (the sufficient stop)', isCorrect: true },
      { id: 'c', text: 'Al-waqf al-ḥasan (the sound/good stop)', isCorrect: true },
      { id: 'd', text: 'Al-waqf al-qabīḥ (the undesirable stop)', isCorrect: true }
    ],
    explanation: 'When considering the place where the qāriʾ stops, waqf is also of four types: al-waqf at-tāmm (the complete stop), al-waqf al-kāfī (the sufficient stop), al-waqf al-ḥasan (the sound/good stop), and al-waqf al-qabīḥ (the undesirable stop).',
    topic: 'taj101'
  },
  {
    id: 'taj090',
    text: 'What is al-waqf at-tāmm (the complete stop)?',
    type: 'single',
    options: [
      { id: 'a', text: 'A stop where both the sentence and meaning are complete with no connection to what follows', isCorrect: true },
      { id: 'b', text: 'A stop where the meaning is connected but grammar is not', isCorrect: false },
      { id: 'c', text: 'A stop where the sentence has a complete meaning but is connected to what follows', isCorrect: false },
      { id: 'd', text: 'A stop where the sentence is incomplete', isCorrect: false }
    ],
    explanation: 'Al-waqf at-tāmm (the complete stop) occurs when the qāriʾ makes waqf in such a place where the sentence, as well as the meaning, is complete and there is no connection between it and what follows.',
    topic: 'taj101'
  }
];
